<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-cash-multiple"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $tc('claims') }}
        </div>
      </template>
      <v-btn
        :color="'primary'"
        :disabled="!selectedLines.length && !totalItems && !['approved', 'rejected_by_economy'].includes(filterOptions.status.filter)"
        @click="acceptBulk"
      >
        {{ $t('bulk_accept', {count: selectedLines.length || totalItems}) }}
      </v-btn>
      <v-btn
        :color="'primary'"
        @click="createBankFile"
      >
        {{ $t('create_bank_file') }}
      </v-btn>

      <v-divider class="my-3" />

      <v-data-table
        v-model="selectedLines"
        :headers="headers"
        :items="items"
        item-key="token"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        show-select
        dense
        class="elevation-1"
      >
        <template v-slot:item.is_internal="{item}">
          <v-icon
            v-if="item.is_internal"
            medium

            class="mr-5"
            color="green"
          >
            check
          </v-icon>
          <v-icon
            v-else
            medium
            color="red"
            class="mr-5"
          >
            not_interested
          </v-icon>
        </template>
        <template v-slot:item.status="{ item }">
          {{ statuses[item.status] }}
        </template>
        <template v-slot:item.customer_name="{ item }">
          {{ item.customer.company_name || item.customer.name }}
        </template>
        <template v-slot:item.by_credit_type="{ item }">
          {{ creditTypes[item.credit_type] }}
        </template>
        <template v-slot:item.bank_information="{item}">
          <template v-if="item.credit_type !== 'invoice'">
            {{ item.account_registration_number }} {{ item.account_number }}
          </template>
        </template>
        <template v-slot:item.value="{ item }">
          {{ item.value }} {{ item.currency_code }}
        </template>

        <template v-slot:item.compensation_value="{ item }">
          {{ item.compensation_value }} {{ item.compensation_currency_code }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              v-if="!['verified_by_economy', 'payment_created'].includes(item.status)"
              medium

              class="mr-5"
              color="green"
              alt="Godkend"
              @click="accept(item.token)"
            >
              check
            </v-icon>
            <v-icon
              v-if="!['rejected_by_economy', 'payment_created'].includes(item.status)"
              medium
              color="red"
              class="mr-5"
              alt="Afvis"
              @click="reject(item.token)"
            >
              not_interested
            </v-icon>
          </v-row>
        </template>
        <template v-slot:body.prepend>
          <filter-row
            v-if="filtersReady"
            show-select
            :filter-options="filterOptions"
            :headers="headers"
            :filter="filter"
            @set-filter="setFilter"
          />
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'

  export default {
    mixins: [List],
    data (vm) {
      return {
        endpoint: 'claims',
        name: 'claims',
        headers: [
          {
            sortable: false,
            text: this.$t('internal'),
            value: 'is_internal',
          },

          {
            sortable: false,
            text: this.$t('customer_id'),
            value: 'shipment.customer_id',
          },
          {
            sortable: false,
            text: this.$t('customer'),
            value: 'customer_name',
          },
          {
            sortable: false,
            text: this.$t('carrier'),
            value: 'shipment.carrier',
          },
          {
            sortable: false,
            text: this.$t('package_number'),
            value: 'shipment.package_number',
            width: '100%',
          },
          {
            text: this.$t('bank_information'),
            value: 'bank_information',
          },
          {
            text: this.$t('status'),
            value: 'status',
          },
          {
            text: this.$t('created'),
            value: 'created_at',
            type: 'datetime',
          },
          {
            text: this.$t('credit_type'),
            value: 'by_credit_type',
          },
          {
            text: this.$t('value'),
            value: 'value',
          },
          {
            text: this.$t('compensation'),
            value: 'compensation_value',
          },

          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        filter: { status: 'approved' },
        filterOptions: {
          is_internal: {
            label: this.$t('internal'),
            type: 'single',
            options: [
              { slug: '1', label: this.$t('yes') },
              { slug: '0', label: this.$t('no') },
            ],
          },
          'shipment.customer_id': {
            label: this.$t('customer_id'),
            type: 'range',
            filter: {},
          },
          'shipment.carrier': {
            label: this.$t('carrier'),
            type: 'single',
            options: vm.$store.state.carriers,
          },

          'shipment.package_number': {
            label: this.$t('package_number'),
            type: 'free',
            filter: '',
          },
          created_at: {
            label: this.$t('created'),
            type: 'date-range',
            filter: {},
          },
          status: {
            label: this.$t('status'),
            type: 'single',
            options: [{ slug: 'approved', label: 'Godkendt' }, { slug: 'verified_by_economy', label: 'Godkendt af økonomi' }, { slug: 'rejected_by_economy', label: 'Afvist af økonomi' }, { slug: 'payment_created', label: 'Kreditnota oprettet' }],
            filter: ['approved'],
          },
          by_credit_type: {
            label: this.$t('credit_type'),
            type: 'single',
            options: [],
          },
        },
        statuses: {},
        creditTypes: {},
        settingStatus: false,
      }
    },
    computed: {
      filtersReady: function () {
        return !this.$_.isEmpty(this.statuses) && !this.$_.isEmpty(this.creditTypes)
      },
    },
    watch: {
      items: function () {
        this.selectedLines = []
      },
    },
    created: function () {
      this.getStatuses()
      this.getCreditTypes()
    },
    methods: {
      getStatuses: function () {
        this.$get('/claims/statuses').then(({ data }) => {
          this.statuses = data
        })
      },
      createBankFile: function () {
        this.$get('/claims/payment-files').then(({ data }) => {
          this.statuses = data
        })
      },
      getCreditTypes: function () {
        this.$get('/claims/credittypes').then(({ data }) => {
          this.creditTypes = data
          this.filterOptions.by_credit_type.options = this.$_.map(data, (label, slug) => ({ label, slug }))
        })
      },

      accept: function (token, status, note) {
        this.settingStatus = true
        this.$post(`/claims/${token}/economy/accept`).then(r => {
          this.getDataFromApi()
        }).finally(() => {
          this.settingStatus = false
        })
      },
      acceptBulk () {
        const confirmText = this.$t('confirm_bulk_accept', { entity: this.$t('claims').toLowerCase(), count: this.selectedLines.length || this.totalItems })
        if (confirm(confirmText)) {
          this.loading = true

          this.$post('/claims/bulk/economy/accept/', { include: this.$_.map(this.selectedLines, 'token') }, { query: { filters: this.filter } })
            .then(response => {
              this.getDataFromApi()
            })
            .catch(e => {
              this.loading = false
            })
        }
      },

      reject: function (token) {
        const note = prompt(this.$t('enter_reason_for_rejection'))
        if (!note) { return }
        this.settingStatus = true
        this.$post(`/claims/${token}/economy/reject`, { note, date: this.$moment().format('YYYY-MM-DD HH:mm:ss'), user_id: `ECONOMIC_${this.$getUser().name}` }).then(r => {
          this.getDataFromApi()
        }).finally(() => {
          this.settingStatus = false
        })
      },
    },
  }
</script>
